'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    GlowEffectWrapper: ()=>GlowEffectWrapper
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../../hooks/index.cjs");
const external_GlowEffect_cjs_namespaceObject = require("./GlowEffect.cjs");
function GlowEffectWrapper({ active = false, children, colors = [
    '--color-penny-8',
    '--color-penny-15',
    '--color-penny-14',
    '--color-penny-13'
], mode = 'colorShift', duration = 300 }) {
    const [convertedColors, setConvertedColors] = (0, external_react_namespaceObject.useState)([]);
    const { convertMultipleVars, clearCache } = (0, index_cjs_namespaceObject.useOklchToRgb)();
    (0, external_react_namespaceObject.useEffect)(()=>{
        setConvertedColors(convertMultipleVars(colors));
        const observer = new MutationObserver(()=>{
            clearCache();
            setConvertedColors(convertMultipleVars(colors));
        });
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: [
                'class',
                'style'
            ]
        });
        return ()=>observer.disconnect();
    }, [
        colors,
        convertMultipleVars,
        clearCache
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "relative p-2",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.div, {
                className: "pointer-events-none absolute inset-0 z-[-1] opacity-0",
                animate: {
                    opacity: active ? 1 : 0
                },
                transition: {
                    duration,
                    ease: 'easeOut'
                },
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_GlowEffect_cjs_namespaceObject.GlowEffect, {
                    colors: convertedColors,
                    mode: mode,
                    blur: "medium",
                    duration: duration
                })
            }),
            children
        ]
    });
}
exports.GlowEffectWrapper = __webpack_exports__.GlowEffectWrapper;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "GlowEffectWrapper"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
